export async function facebookInvite(url: string) {
	// simplest web fallback: open sharer URL
	const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;

	window.open(shareUrl, '_blank', 'noopener,noreferrer,width=600,height=700');
	return { opened: true };
}
